module.exports = __webpack_public_path__ + "static/Caroline-4be79b458b3babdc89b8fafc1fc8331c.jpg";